import React, { useEffect, useState } from "react";
import i18n from "i18next"; // i18n library for internationalization
import { LanguageContainer, LanguageOption, LanguageOptionContainer, LanguageOptionValue } from "../../styles/list/styles";
import { LanguageIcon } from "./styles";
import { getData } from "../../../backend/api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguages } from "../../../store/actions/languages";
import german from "../../../images/language/german.png";
import english from "../../../images/language/english.png";
function LanguageTooltip({bg,actBg,page}) {
  const dispatch = useDispatch();
  const language = useSelector((state)=> state.languages?.data)
  const [showLanguageOption, setShowLanguageOption] = useState(false);
  const [t] = useTranslation();
  // State to store the selected language
  const [selectedLanguage, setSelectedLanguage] = useState(
    // If a language is stored in local storage, use it, otherwise use "de"
    sessionStorage.getItem("_lang") !== null ? sessionStorage.getItem("_lang") : "de"
  );

  // Function to handle language change
  const handleLanguageChange = (language) => {
    // Change the language in the i18n library
    i18n.changeLanguage(language);
    // Store the selected language in local storage
    sessionStorage.setItem("_lang", language);
    // Update the selectedLanguage state
    setSelectedLanguage(language);
    window.location.reload();
  };

  // const fetchLanguage = () => {
  //   dispatch(fetchLanguages());
  // }

  // useEffect(() => {
  //    fetchLanguage();
  // }, [])
  

  return (
    <LanguageContainer onClick={()=> setShowLanguageOption(true)} className={`${page}`} bg={bg} actBg={actBg} onMouseEnter={()=> setShowLanguageOption(true)}
    onMouseLeave={()=> setShowLanguageOption(false)}>
      <LanguageIcon bg={bg} actBg={actBg} className={`active ${page}`}>
        {selectedLanguage && <img style={{width: page?.includes("login") ? '16px':'20px', height: page?.includes("login")?'16px':'20px', margin: 0}} src={selectedLanguage.toLocaleLowerCase()==="de" ? german : selectedLanguage.toLocaleLowerCase()==="en" ? english : "#"} alt={t(selectedLanguage.toLocaleLowerCase())}/> }
        {page?.includes("login") ? (t("changeLanguage")) : (selectedLanguage?.toUpperCase())}
      </LanguageIcon>
      {showLanguageOption && <LanguageOptionContainer className={`${page}`}> <LanguageOption className={`${page}`} >
        {Array.isArray(language) && language?.map((item, index) => (
          <LanguageOptionValue  key={index} className={`${selectedLanguage?.toLowerCase() === item.value?.toLowerCase() ? "active" : ""} ${page} `} onClick={() => handleLanguageChange(item.value?.toLowerCase())} >
             <img style={{ width: page?.includes("login") ? '16px': '20px', height: page?.includes("login") ? '16px': '20px',margin: 0}} src={item.value?.toLocaleLowerCase()==="de" ? german : item.value?.toLocaleLowerCase()==="en" ? english : "#"} alt={t(item.value?.toLocaleLowerCase())}/>
            {t(item.value?.toLowerCase())}
          </LanguageOptionValue>
        ))}
      </LanguageOption>
      </LanguageOptionContainer>}
      {/* <LanguageIcon bg={bg} actBg={actBg} className={selectedLanguage === "de" ? "active" : ""} onClick={() => handleLanguageChange("de")}>
        DE
      </LanguageIcon>
      <LanguageIcon bg={bg} actBg={actBg} className={selectedLanguage === "en" ? "active" : ""} onClick={() => handleLanguageChange("en")}>
        EN
      </LanguageIcon> */}
    </LanguageContainer>
  );
}

export default LanguageTooltip;
